import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type SidebarMenuItemProps = ComponentProps<'li'>;

const SidebarMenuItem = ({ className, ...props }: SidebarMenuItemProps) => {
  return (
    <li
      data-slot="sidebar-menu-item"
      data-sidebar="menu-item"
      className={cn('group/menu-item relative', className)}
      {...props}
    />
  );
};

export default SidebarMenuItem;
